import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RTLLayout from './layouts/rtl';
import {
  ChakraProvider,
} from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import Login from 'pages/Login';
import AdminRoutes from 'routes/AdminRoutes';
import UserActivation from 'pages/users/UserActivation';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
import SystemConfiguration from 'pages/SystemConfiguration';

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route path="/" element={<SystemConfiguration />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/activation-success" element={<UserActivation />} />

        {/* <Route path="auth/*" element={<AuthLayout />} /> */}
        <Route
          path="admin/*"
          element={
            <AdminRoutes>
              <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
            </AdminRoutes>
          }
        />
        {/* <Route
          path="rtl/*"
          element={
            <RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />
          }
        /> */}
        <Route path="/" element={<Navigate to="/admin" replace />} />
      </Routes>
    </ChakraProvider>
  );
}
